export default __webpack_public_path__ + "static/media/95.b0923d2c.jpg";